<script>
import PropostaList from '@/components/shared/proposta/PropostaList.vue'

export default {
  extends: PropostaList,
}
</script>
